"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainEventBase = void 0;
const uuid = require("uuid");
const EventSchema_1 = require("./schema/EventSchema");
const EventPropertyDecorator_1 = require("./schema/EventPropertyDecorator");
class DomainEventBase {
    constructor(eventData) {
        this.uuid = uuid.v4();
        this.timestamp = Date.now();
        if (eventData) {
            for (let key in eventData) {
                if (key === "uuid" || key === "timestamp") {
                    throw new Error(`Can not map override ${key} property`);
                }
                this[key] = eventData[key];
            }
        }
    }
    toDataObject(namespace, executionContext) {
        const payload = { ...this };
        delete payload.uuid;
        delete payload.timestamp;
        delete payload.version;
        const meta = EventSchema_1.getEventSchema(this.constructor);
        const context = {
            executionId: executionContext.executionId,
            correlationId: executionContext.correlationId,
        };
        if (executionContext.transactionId) {
            context.transactionId = executionContext.transactionId;
        }
        if (!meta) {
            throw new Error(`${this.constructor.name} is not a DomainEvent. The class must have the @DomainEvent decorator`);
        }
        return {
            id: this.uuid,
            timestamp: this.timestamp,
            version: meta.version,
            namespace,
            name: meta.eventName,
            context,
            payload,
        };
    }
}
__decorate([
    EventPropertyDecorator_1.EventProperty(),
    __metadata("design:type", String)
], DomainEventBase.prototype, "uuid", void 0);
__decorate([
    EventPropertyDecorator_1.EventProperty(),
    __metadata("design:type", Number)
], DomainEventBase.prototype, "timestamp", void 0);
exports.DomainEventBase = DomainEventBase;
//# sourceMappingURL=EventBase.js.map